import { createReducer, on } from '@ngrx/store';
import { WhiteLabelConfig, loadWhiteLabelConfigSuccess } from './white-label.actions';

// Goliiive default values used as fallback when no config is loaded yet
const defaultConfig: WhiteLabelConfig = {
  // Mismo azul de marca que usa el servicio; ver `white-label.service.ts`.
  primary_color: '#1897df',
  secondary_color: '#6366F1',
  tertiary_color: '#141414',
  logo_main_url: '/assets/images/brand/goliiive_logo_blue_no_tagline.svg',
  logo_iso_url: '/assets/images/brand/goliiive_logo_blue_iso.svg',
  logo_white_url: '/assets/images/brand/goliiive_logo_white_no_tagline.svg',
  favicon_url: 'favicon.ico',
  background_auth_url: '/assets/images/general/live_event.jpeg',
};

const storedConfig = localStorage.getItem('whiteLabelConfig');
const initialState: WhiteLabelConfig = storedConfig
  ? JSON.parse(storedConfig)
  : defaultConfig;

export const whiteLabelReducer = createReducer(
  initialState,
  on(loadWhiteLabelConfigSuccess, (_state, { config }) => ({ ...config }))
);
